import { useUserSession } from '@solinkcorp/authentication';
import settings from '@solinkcorp/settings';
import { useMemo } from 'react';
import { clientVD } from 'vd-server/client';

export const useClientVD = () => {
  const { accessToken } = useUserSession();
  return useMemo(() => {
    return clientVD(settings.vdApiUrl, {
      headers() {
        return {
          Authorization: `Bearer ${accessToken}`,
        };
      },
    });
  }, [accessToken]);
};
